import * as React from "react";
function SvgFocus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M18.9 9.5h-2.8V15h-5.6v2.8h5.6v5.6h2.8v-5.6h5.6V15h-5.6V9.5zm12.8 17.1C37 18.8 35 8.2 27.2 2.9 24.6 1.1 21.4 0 18 0h-.7C8.1 0 .8 7.4.8 16.6.5 25.9 7.9 33.7 17.2 34h.4c3.1 0 6.1-.8 8.9-2.5l-.1.1L42 48l5.3-5c-.1 0-15.6-16.4-15.6-16.4zm-14 4.6h-.4c-7.8-.3-14-6.7-13.9-14.6C3.8 9 10 3.1 17.5 2.6h.4c7.8.3 13.9 7 13.6 14.7-.1 7.7-6.2 13.7-13.8 13.9zm11-1.3l1.3-1.3 13.5 14.2-1.3 1.3-13.5-14.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFocus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
